import { Button, Form, Select } from 'antd';
import { useForm, Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { forwardRef, useImperativeHandle } from 'react';

const UserForm = forwardRef(function UserForm(
  { formValues, onSubmit, loading, isEdit = false },
  ref
) {
  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
    reset,
  } = useForm({
    values: formValues,
  });

  useImperativeHandle(
    ref,
    () => ({
      reset: reset,
    }),
    [reset]
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="form-group">
        <label
          style={{
            zIndex: 10000,
          }}
        >
          Title <span className="login-danger">*</span>
        </label>
        <Controller
          name="nameTitle"
          control={control}
          disabled={isEdit}
          defaultValue={'Mr'}
          rules={{ required: true }}
          render={({ field }) => (
            <Select
              {...field}
              className="form-control menu-classM"
              options={[
                {
                  value: 'Mr',
                  label: 'Mr',
                },
                {
                  value: 'Mrs',
                  label: 'Mrs',
                },
                {
                  value: 'Ms',
                  label: 'Ms',
                },
                {
                  value: 'Dr',
                  label: 'Dr',
                },
                {
                  value: 'Sister',
                  label: 'Sister',
                },
              ]}
            />
          )}
        />

        <small style={{ color: 'red' }}>
          {errors.nameTitle && <p>Please enter Title</p>}
        </small>
      </div>
      <div className="form-group">
        <label>
          First Name <span className="login-danger">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          disabled={isEdit}
          {...register('firstName', { required: true })}
        />
        <small style={{ color: 'red' }}>
          {errors.firstName && <p>Please enter First name</p>}
        </small>
      </div>
      <div className="form-group">
        <label>
          Last Name <span className="login-danger">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          disabled={isEdit}
          {...register('lastName', { required: true })}
        />
        <small style={{ color: 'red' }}>
          {errors.lastName && <p>Please enter Last name</p>}
        </small>
      </div>
      <div className="form-group">
        <label>
          Email <span className="login-danger">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          disabled={isEdit}
          {...register('email', {
            required: 'Please enter Your Email!',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Please enter A Valid Email!',
            },
          })}
        />
        <small style={{ color: 'red' }}>{errors.email?.message}</small>
      </div>
      <div className="form-group">
        <label
          style={{
            zIndex: 10000,
          }}
        >
          Module <span className="login-danger">*</span>
        </label>
        <Controller
          name="modules"
          control={control}
          defaultValue={['CASE']}
          rules={{ required: true }}
          render={({ field }) => (
            <Select
              {...field}
              className="form-control menu-classM"
              mode="multiple"
              options={[
                { value: 'CASE', label: 'CASE' },
                { value: 'ACCOUNT', label: 'ACCOUNT' },
                { value: 'REPORT', label: 'REPORT' },
              ]}
            />
          )}
        />
        <small style={{ color: 'red' }}>
          {errors.title && <p>Please enter Module</p>}
        </small>
      </div>
      {isEdit ? (
        <div className="form-group form-check">
          <input
            id="flexCheckDefault"
            className="form-check-input"
            type="checkbox"
            defaultChecked
            {...register('status')}
          />
          <label className="form-check-label w-100" htmlFor="flexCheckDefault">
            Status
          </label>
        </div>
      ) : null}
      <Form.Item>
        <Button
          key="ok"
          type="primary"
          htmlType="submit"
          block
          loading={loading}
        >
          Submit
        </Button>
      </Form.Item>
    </form>
  );
});
UserForm.propTypes = {
  formValues: PropTypes.object,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  isEdit: PropTypes.bool,
};
export default UserForm;
